import './modelsRegistry'

import {initializeFooter} from './footer';
import {initialize as initializeHeaderControls} from './vue/containers/HeaderControlsContainer'
import {cookiesPrivacyPolicy} from './libraries/cookies-privacy/CookiesPrivacyPolicy';
import {topHeader} from './libraries/TopHeader';
import {AlcoholBox} from './libraries/alcohol-box';
import {Popup} from "./libraries/popup";
import {toast} from './libraries/toast';
import 'script-loader!./libraries/jquery.ui.totop.min';
import 'script-loader!./libraries/jquery.textarea_limit';

import Vue from 'vue';
import {SecurityContainer} from "./libraries/SecurityContainer";
import {HashRouter} from "./libraries/HashRouter";
import {GetResponseApi} from "./libraries/GetResponseApi";

function initializeLoginPopup() {
    let loginContainerInstance = null;

    const showHandler = () => {
        if (HashRouter.isRoute('login-modal')) {
            if (!loginContainerInstance) {
                import("./vue/containers/LoginPopupContainer")
                    .then(module => {
                        const container = document.createElement('div');
                        document.body.appendChild(container);

                        loginContainerInstance = new Vue(module.default);
                        loginContainerInstance.$mount(container);
                        loginContainerInstance.openModal();
                    })
                ;
            } else {
                loginContainerInstance.openModal();
            }
        } else if (loginContainerInstance) {
            loginContainerInstance.closeModal();
        }
    };

    showHandler();
    window.addEventListener("hashchange", showHandler);
}

const typeText = 'Wyszukaj prezent ';
let iText = 0;

function initializeTypeWrite() {
    let text = typeText.slice(0, ++iText);
    if (text === typeText) return;

    document.getElementById('szukajname').placeholder = text;

    setTimeout(initializeTypeWrite, 80);
}

function initialize() {
    topHeader();
    initializeFooter();

    if (document.querySelector('.main-header-controls')) {
        initializeHeaderControls();
    }

    if (false === SecurityContainer.userIsLogged()) {
        initializeLoginPopup();
    }

    if (typeof POPUP_DATE_START !== 'undefined' &&
        typeof POPUP_ID !== 'undefined') {

        var dateStart = new Date(POPUP_DATE_START);
        var dateEnd = null;

        if (POPUP_DATE_END !== '') {
            dateEnd = new Date(POPUP_DATE_END);
        }

        const popup = new Popup(
            dateStart,
            dateEnd
        );

        if (popup.isPopupVisible()) {
            popup.showPopup(POPUP_ID);
        } else {
            popup.hidePopup();
        }
    }

    setTimeout(function() {
        cookiesPrivacyPolicy()
    }, 3000);

    if (false !== SecurityContainer.userIsLogged()) {
        const user = SecurityContainer.getLoggedUser();

        setTimeout(function() {
            GetResponseApi.setUserId(user.email);
        }, 1000);
    }

    setTimeout(function() {
        if (typeof tiktok_identify == 'function') {
            tiktok_identify(globalHashedId, globalHashedEmail);
        }
    }, 1000);

    if (document.querySelector('#szukajname')) {
        setTimeout(function() {
            initializeTypeWrite();
        }, 1000);
    }
}

window.toast = toast;

const alcoholBox = new AlcoholBox();
if (showAlcoholAlert == 1) {
    alcoholBox.show();
} else {
    alcoholBox.hide();
}

document.addEventListener('DOMContentLoaded', initialize);
